module.exports = __webpack_public_path__ + "img/3-IMG_3001.f13f7976.png";